import { Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import "./FilterSection.css";

interface FilterSectionProps {
    selectedSituation?: string[];
    handleSituationFilter: (value: string | string[]) => void;
    allSituations?: string[];
}

const FilterSection = ({
    selectedSituation = [],
    handleSituationFilter,
    allSituations = [],
}: FilterSectionProps) => {
    const handleCheckboxChange = (label: string) => {
        handleSituationFilter(label);
    };

    const isAllSelected =
        allSituations.length > 0 &&
        allSituations.every((s) => selectedSituation.includes(s));

    const handleToggleAll = () => {
        if (isAllSelected) {
            handleSituationFilter([]);
            return;
        }

        handleSituationFilter([...allSituations]);
    };

    return (
        <div className="filters-section">
            <div className="filter-label">
                <FaFilter style={{ marginRight: "6px" }} /> Situação:
            </div>

            <div className="checkbox-grid shipping-checkbox-grid-inline">
                <Form.Check
                    inline
                    label="Todos"
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleToggleAll}
                />

                <Form.Check
                    inline
                    label="Documentação Pendente"
                    type="checkbox"
                    checked={selectedSituation.includes("Documentação Pendente")}
                    onChange={() => handleCheckboxChange("Documentação Pendente")}
                />

                <Form.Check
                    inline
                    label="Documentação Enviada"
                    type="checkbox"
                    checked={selectedSituation.includes("Documentação Enviada")}
                    onChange={() => handleCheckboxChange("Documentação Enviada")}
                />

                <Form.Check
                    inline
                    label="Adequação Pendente"
                    type="checkbox"
                    checked={selectedSituation.includes("Adequação Pendente")}
                    onChange={() => handleCheckboxChange("Adequação Pendente")}
                />

                <Form.Check
                    inline
                    label="Análise Concluída"
                    type="checkbox"
                    checked={selectedSituation.includes("Análise Concluída")}
                    onChange={() => handleCheckboxChange("Análise Concluída")}
                />

                <Form.Check
                    inline
                    label="Inapto"
                    type="checkbox"
                    checked={selectedSituation.includes("Inapto")}
                    onChange={() => handleCheckboxChange("Inapto")}
                />
            </div>
        </div>
    );
};

export default FilterSection;